import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay } from 'swiper';
import { MarketingTextSlogan } from "../MarketingTextSlogan";
import { MarketingCarouselUserSliderWrapper, MarketingCarouselUserWrapper } from "./MarketingCarouselUser.styles"
import { CarouselUserPledge, UserCard } from "./UserCard";

const users: CarouselUserPledge[] = [{
    name: "Josh Constine",
    handle: "@JoshConstine",
    pledge: <>If you're a journalist, immediately <strong>back up all your articles with Authory</strong>.  <br /><br />It scrapes your posts and makes downloadable copies so the overlords can't destroy your work.</>,
    url: "https://authory.com/JoshConstine",
}, {
    name: "Kristy Puchko",
    handle: "@KristyPuchko",
    pledge: <>For writers/journalists who freelance, <strong>I can't recommend Authory enough for collecting and preserving your work</strong>. I've seen a lot of my writing lost when a site folds or a change in web design deadlinks plenty of pieces.</>,
    url: "https://authory.com/KristyPuchko",
}, {
    name: "Dwight Silverman",
    handle: "@dsilverman",
    pledge: <>I've been using the Authory portfolio service for a while, <strong>and it just keeps getting better.</strong> You can now import your entire Twitter feed into it, and even better, you can import individual threads.</>,
    url: "https://authory.com/dsilverman",
}, {
    name: "Marijana Kay",
    handle: "@MarijanaKay",
    pledge: <><strong> Authory is fantastic</strong> and so versatile/customizable for different niches/goals you have for clients!<br /><br /> Give it a try!</>,
    url: "https://authory.com/MarijanaKostelac",
}, {
    name: "Carlton Reid",
    handle: "@carltonreid",
    pledge: <>All of my articles (including full text) are stored for ever on Authory. Even if a major publication goes pop, my articles would be saved. <strong>In the currently febrile media landscape, Authory is a little bit of sanity</strong>.</>,
    url: "https://authory.com/CarltonReid",
}, {
    name: "Maggie Lovitt",
    handle: "@maggieofthetown",
    pledge: <><strong>If you're a writer and you don't have Authory, I would highly suggest that you invest in it</strong>. Especially if you want to ensure that no one can wipe out two years of work, in what appears to be an effort to erase your existence.</>,
    url: "https://authory.com/MaggieLovitt",
}, {
    name: "Amelia E.",
    handle: "@ThatWitchMia",
    pledge: <><strong>Authory is a great, great, great resource for freelance portfolios</strong>. Especially for websites that go under (it saves it separately, so long as it pulls from the source prior to archive).</>,
    url: "https://authory.com/AmeliaEmberwing",
}, {
    name: "Matt Donato",
    handle: "@DoNatoBomb",
    pledge: <>If you write online,<strong> I highly recommend Authory</strong>. <br /> <br />Best $$ I spend every month.</>,
    url: "https://authory.com/MattDonato",
}];

interface MarketingCarouselUserProps {
    homepageVariant?: boolean,
    text?: string | JSX.Element
}

export const MarketingCarouselUser = ({ homepageVariant = false, text = "Loved by 1,000s of writers, journalists, content marketers and thought leaders" }: MarketingCarouselUserProps) => {
    return <MarketingCarouselUserWrapper>
        <MarketingTextSlogan
            text={text}
            homepageVariant={homepageVariant}
        />
        <MarketingCarouselUserSliderWrapper>
            <Swiper
                spaceBetween={15}
                autoplay={{ delay: 6000, pauseOnMouseEnter: true, disableOnInteraction: false }}
                loop
                speed={2000}
                slidesPerView={1}
                modules={[Autoplay]}
                breakpoints={{
                    550: {
                        slidesPerView: 2,
                    },
                    840: {
                        slidesPerView: 3,
                    },
                    1100: {
                        slidesPerView: 4,
                    },
                    1550: {
                        slidesPerView: 5,
                    }
                }}
            >
                {users.map((userPledge, index) => <SwiperSlide key={index}>
                    <UserCard userPledge={userPledge} index={index} />
                </SwiperSlide>)}
            </Swiper>
        </MarketingCarouselUserSliderWrapper>
    </MarketingCarouselUserWrapper>
}

export default MarketingCarouselUser;